import React, { useState, useMemo } from 'react';
import { Box, Paper, IconButton, Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { screenshotNames } from '../common/constants';
import BodySecondaryText from './BodySecondaryText';

type SampleScreenshotProps = {
  platform: string;
  postFormat: string;
  type?: string;
};

const SampleScreenshot: React.FC<SampleScreenshotProps> = ({ platform, postFormat, type }) => {
  const [open, setOpen] = useState(false);
  const [detailImagePath, setDetailImagePath] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = (path: string) => {
    setOpen(true);
    setDetailImagePath(path);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sampleScreenshotNames = useMemo(() => {
    let sampleImages = screenshotNames.filter((item: string) => item.includes(`${platform}${type || ''}${postFormat}`));
    if (!sampleImages?.length) {
      sampleImages = screenshotNames.filter((item: string) => item.includes(`${platform}${postFormat}`));
    }
    return sampleImages;
  }, [platform, postFormat, type]);

  return (
    <Box position="relative" display="flex" flexDirection="row" flexWrap="wrap" gap={1}>
      {sampleScreenshotNames.length > 0 && (
        <BodySecondaryText>
          Refer to the sample screenshots below to ensure you capture the correct insights before submitting your report.
        </BodySecondaryText>
      )}
      {sampleScreenshotNames.map((item: string, index: number) => (
        <Paper
          key={index}
          elevation={3}
          sx={{
            width: 100,
            height: 100,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            key={index}
            src={`sample-screenshots/${item}`}
            alt="Sample screenshots"
            onClick={() => handleClickOpen(`sample-screenshots/${item}`)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              cursor: 'pointer',
            }}
          />

          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogContent
              sx={{
                position: 'relative',
                p: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'black',
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  zIndex: 1,
                }}
              >
                <CloseIcon />
              </IconButton>

              <img
                src={detailImagePath}
                alt="Detailed View"
                style={{
                  width: isMobile ? '100%' : '600px',
                  height: isMobile ? 'auto' : '800px',
                  maxWidth: '100%',
                  maxHeight: '90vh',
                  overflow: 'hidden',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </DialogContent>
          </Dialog>
        </Paper>
      ))}
    </Box>
  );
};

export default SampleScreenshot;
